<template>
    <div class="iframe-after-template">
        <div class="search-form iframe pt-35 pb-40">
            <div class="container">
                <search-form
                        ref="form"
                        form-class="iframe-form"
                        :show-invalid-message="true"
                        :search-form="searchForm"
                        @search="search">
                </search-form>
            </div>
        </div>
    </div>
</template>
<script>
    import SearchFlightMixin from '../../mixins/SearchFlightMixin';
    import SearchHelpersMixin from '../../mixins/SearchHelpersMixin';
    import SearchForm from './Forms/SearchForm';

    export default {
        mixins: [SearchFlightMixin, SearchHelpersMixin],
        components: {
            SearchForm
        },
        beforeCreate: function () {
            document.documentElement.className = 'iframe';
        },
        data() {
            return {
                searchForm: {
                    airportFrom: null,
                    airportTo: null,
                    dateRange: '',
                },
            }
        },
        methods: {
            updateRoute() {
                let route = process.env.VUE_APP_BASE_URL + 'trip/search?';

                // console.log(route)
                
                const params = [];

                if (this.searchForm.airportFrom) {
                    params.push('from=' + this.searchForm.airportFrom.id);
                }

                if (this.searchForm.airportTo) {
                    params.push('to=' + this.searchForm.airportTo.id)
                }

                if (this.searchForm.dateRange && this.searchForm.dateRange[0]) {
                    params.push('range=' + this.searchForm.dateRange[0]);
                    params.push('range=' + this.searchForm.dateRange[1]);
                }

                window.top.location.href = route + params.join('&');
            },
        },
        /* watch: {
            '$route.query'() {
                this.updateTripList();
            }
        } */
    }
</script>

<style scoped>
    /deep/ #subscribe-modal {
        background: none;
    }
</style>

<style>

    .mx-input-wrapper {
        max-width: 250px;
    }

    form.iframe-form {
        background-color: rgba(250, 250, 250, 0.7);
    }

    .text-gray {
        color: gray;
    }

    .search-form.iframe {
        height: 700px;
    }

    html.iframe {
        overflow: hidden;
    }

    .iframe-after-template {
        background-color: transparent;
    }

    .search-form.iframe {
        background-color: transparent !important;
    }

    html.iframe body {
        overflow-x: hidden;
        background-color: transparent;
    }

    .search-trip-form .form-control.is-valid {
        padding-right: 0;
    }

    .error-from {
        top: 121px;
    }

    .search-form .container {
        max-width: 1000px;
    }

    .search-form .container .box-shadow {
        max-width: 1000px;
    }

    .airports input {
        max-width: 225px;
    }

    .search-form .container .date-rage-picker input {
        min-width: 255px;
    }

    .v-autocomplete-list {
        background-color: white;
        border: solid black 1px;
    }

    .btn.btn-primary.iframe-button {
        background-color: #2597D8;
        border-color: #2597D8;
    }

    @media (max-width: 1024px) {
        p.upper-text.search {
            width: 350px;
            margin: 0;
        }
    }

    @media (max-width: 900px) {
        .container .box-shadow.search-trip-form {
            max-width: 600px;
            margin: auto;
            flex-flow: wrap;
            justify-content: space-around;
        }

        .from-input,
        .toggle-airports,
        .to-input {
            margin-bottom: 30px !important;
            margin-right: 0 !important;
        }

        .mx-datepicker-range,
        .mx-input-wrapper {
            width: 100%;
        }

        .form-control.date-picker,
        .mx-input-wrapper {
            width: 100%;
            max-width: 100%;
        }

        .form.control.date-rage-picker {
            margin-bottom: 30px;
        }

        .from-input input.form-control,
        .to-input input.form-control {
            max-width: none;
        }

    }

    @media (max-width: 610px) and (min-width: 561px) {

        .iframe #from-input,
        .iframe #to-input {
            width: 225px;
        }

    }

    @media (max-width: 560px) {
        .iframe .from-input,
        .iframe .to-input,
        .iframe .form-control.date-picker,
        .iframe .mx-input-wrapper {
            width: 100%;
            max-width: 500px;
        }

        .v-autocomplete {
            width: 100%;
        }

        .form-control.date-range-picker {
            display: flex;
            justify-content: center;
        }
    }

    @media (max-width: 319px) {
        html.iframe body {
            min-width: 100px;
        }

        .search-form.iframe > .container {
            width: 90vw;
            margin: 0 auto;
            padding: 0;
        }

        .search-form.iframe .search-trip-form {
            padding: 15px 10px !important;
        }

        .search-form.iframe .from-input,
        .search-form.iframe .to-input,
        .search-form.iframe .toggle-airports {
            margin-bottom: 20px !important;
        }

        .search-form.iframe .container .date-rage-picker input {
            min-width: 100px;
        }
    }

</style>
